import { Router } from '@angular/router';
import { CommonService } from './../../../services/common/common.service';
import { IOption } from './../../../ui/interfaces/option';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { BasePageComponent } from '../../base-page';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { IAppState } from 'src/app/interfaces/app-state';
import { Store } from '@ngrx/store';
import { HttpService } from 'src/app/services/http/http.service';
import { TCModalService } from 'src/app/ui/services/modal/modal.service';
import { Content } from 'src/app/ui/interfaces/modal';
import * as SjtActions from './../../../store/actions/stocks.actions';
import * as JaugeagesActions from './../../../store/actions/jaugeages.actions';
import { JaugeageService } from 'src/app/layout/vertical/jaugeage.service';

@Component({
  selector: 'app-jaugeage-conteneur',
  templateUrl: './jaugeage-conteneur.component.html',
  styleUrls: ['./jaugeage-conteneur.component.scss']
})
export class JaugeageConteneurComponent extends BasePageComponent implements OnInit, OnDestroy {

  pageForm: FormGroup;
  loading = false;
  change: boolean;
  reservoirs: IOption[];
  reservoir: any = '';
  types: IOption[];
  heureJauge = '08:00:00';
  
  constructor(
    store: Store<IAppState>,
    httpSv: HttpService,
    modal: TCModalService,
    private fb: FormBuilder,
    private comS: CommonService,
    private jaugeS: JaugeageService,
    private router: Router
  ) {
    super(store, httpSv, modal);
    this.pageData = {
      title: 'Jaugeage de Conteneur',
      loaded: true,
      breadcrumbs: [
        {
          title: 'Situation journalière',
          route: 'default-dashboard'
        },
        {
          title: 'Jaugeage conteneur'
        }
      ]
    };
    this.types = [
      {
        label: 'stockage',
        value: 'STOCKAGE'
      },
      {
        label: 'fermeture',
        value: 'FERMETURE'
      }
    ];
    this.change = false;
    this.reservoirs = [];
   }

  ngOnInit() { 
    super.ngOnInit();
    const userInfo = JSON.parse(localStorage.getItem('myUser'));
    const depotId =  userInfo.depots_id.id;
    this.store.select('contenants').subscribe(datas => {
      if (datas && datas.length) {
        datas.forEach(contenant => {
          if (contenant.depots_id.id === depotId && contenant.type === 'RESERVOIR') {
            const c: IOption = {label: '', value: ''};
            c.label = contenant.code.toUpperCase() + ' [' + contenant.produits_id.nature.toUpperCase() + ']';
            c.value = contenant.id;
            this.reservoirs.push(c);
            this.reservoir = this.reservoirs[0].value;
          } else {
            if (contenant.type === 'RESERVOIR') {
              const c: IOption = {label: '', value: ''};
              c.label = contenant.code.toUpperCase() + ' [' + contenant.produits_id.nature.toUpperCase() + ']';
              c.value = contenant.id;
              this.reservoirs.push(c);
              this.reservoir = this.reservoirs[0].value;
            }
          }
        });
      }
    });
    this.initForm();
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }

  // open modal window
  openModal<T>(body: Content<T>, header: Content<T> = null, footer: Content<T> = null, row: any = null) {
    this.initForm();
    this.modal.open({
      body,
      header,
      footer,
      options: { height: 'auto', width: 500, closeButton: false, overlay: true, overlayClose: true }
    });
  }

  // close modal window
  closeModal() {
    this.modal.close();
    if (this.pageForm) {
      this.pageForm.reset();
    }
  }

   // init form
   initForm() {
    this.pageForm = this.fb.group({
      date: [new Date(), Validators.required],
      heure: [this.comS.hourString(new Date()), Validators.required],
      reservoir: [this.reservoir, Validators.required],
      hp: [0],
      he: [0],
      tm: [0],
      da: [0],
      ta: [0],
      d15: [0],
      lp: [0],
      leau: [0],
      la: [0, Validators.required],
      l15: [0, Validators.required],
      tmv: [0],
      coef: [0],
      type: ['STOCKAGE'],
      observation: ['']
    });

    // detect form changes
    this.pageForm.valueChanges.subscribe((data) => {
      if (data.type === 'FERMETURE') {
        data.heure = '16:00:00';
        this.heureJauge = '16:00:00';
      }

      if (data.type === 'STOCKAGE') {
        data.heure = '08:00:00';
        this.heureJauge = '08:00:00';
      }
      this.change = true;
    });
  }

  saveData(form: FormGroup) {
    if (form.valid) {
      this.loading = true;
      const newData = form.value;
      newData.date = this.comS.dateString(newData.date);

      this.jaugeS.create(newData)
      .subscribe(
        (data) => {
          this.loading = false;
          this.messageSuccess('Création');
          this.store.dispatch(new JaugeagesActions.Add(data));
          this.jaugeS.getData(this.jaugeS.url + '?ctrl=stock', 'stocks', 'setDataStore', SjtActions);
          setTimeout(() => {
            this.router.navigateByUrl('/vertical/jaugeage');
          }, 4300);
        },
        (error) => {
          this.loading = false;
          this.messageError();
        }
      );
    }
  }

}
